module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/appuntamento-specialistico/appuntamento-specialistico.css
// module id = ./src/app/components/appuntamento-specialistico/appuntamento-specialistico.css
// module chunks = main